export default __webpack_public_path__ + "static/media/Stella Guan.18e46e82.png";